<template>
    <div class="row">
        <div class="col-xl-12">
            <div id="panel-1" class="panel">
                <div class="panel-container show">
                    <div class="panel-content">
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="24" :md="8" :lg="4" :xl="4">
                                <el-input type="text" size="medium" v-model="filter.keyword" class=" mt-3"
                                          placeholder="Nhập tên, mã lớp" autocomplete="false" ></el-input>
                            </el-col>
                            <el-col :xs="24" :sm="24" :md="8" :lg="4" :xl="4">
                                <el-select  v-model="filter.center_id" filterable clearable class="w-100 mt-3" placeholder="Chọn trung tâm" @change="getBranches() ; getCourses()">
                                    <el-option
                                        v-for="item in centers"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                        <span style="float: left">{{ item.name }}</span>
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :xs="24" :sm="24" :md="8" :lg="4" :xl="4">
                                <el-select v-model="filter.operating_area_id" filterable clearable class="w-100 mt-3" placeholder="Khu vực vận hành" multiple @change="getBranches()">
                                    <el-option
                                        v-for="item in regionOptions"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                        <span style="float: left">{{ item.name }}</span>
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :xs="24" :sm="24" :md="8" :lg="4" :xl="4">
                                <el-select v-model="filter.branch_id" filterable clearable class="w-100 mt-3" placeholder="Chi nhánh" multiple>
                                    <el-option
                                        v-for="item in branches"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                        <span style="float: left">{{ item.name }}</span>
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :xs="24" :sm="24" :md="8" :lg="4" :xl="4">
                                <el-select v-model="filter.course_id" filterable clearable class="w-100 mt-3" placeholder="Khóa học" multiple>
                                    <el-option
                                        v-for="item in courseOptions"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                        <span style="float: left">{{ item.name }}</span>
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :xs="24" :sm="24" :md="8" :lg="4" :xl="4">
                                <el-select v-model="filter.recruitment_status" filterable clearable class="w-100 mt-3" placeholder="Trạng thái tuyển sinh" multiple>
                                    <el-option
                                        v-for="item in enrollmentStatus"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                        <span style="float: left">{{ item.name }}</span>
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :xs="24" :sm="24" :md="8" :lg="4" :xl="4">
                                <el-select v-model="filter.schedule" clearable class="w-100 mt-3" placeholder="Lịch học" multiple>
                                    <el-option
                                        v-for="item in scheduleOptions"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                        <span style="float: left">{{ item.name }}</span>
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :xs="24" :sm="24" :md="8" :lg="4" :xl="4">
                                <el-date-picker
                                    class="w-100 mt-3"
                                    v-model="filter.date_range"
                                    type="daterange"
                                    range-separator="-"
                                    start-placeholder="Từ ngày"
                                    end-placeholder="Đến ngày"
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd">
                                </el-date-picker>
                            </el-col>
                            <el-col :xs="24" :sm="24" :md="8" :lg="4" :xl="4">
                                <el-input type="text" size="medium" class=" mt-3" v-model="filter.remaining_slots"
                                          placeholder="Số slot còn lại" autocomplete="false" ></el-input>
                            </el-col>
                        </el-row>

                        <div class="table-responsive w-100 mt-4" v-loading="isLoading">
                            <table class="table table-bordered ">
                                <thead class="table-secondary">
                                    <tr align-items class=" " style="font-size: 13px">
                                      <th >Chi nhánh</th>
                                      <th >Khóa học</th>
                                      <th >Mã lớp</th>
                                      <th >Lịch học</th>
                                      <th >KG sớm nhất</th>
                                      <th >KG muộn nhất</th>
                                      <th >KG chính thức</th>
                                      <th >Trạng thái</th>
                                      <th >Sĩ số chuẩn</th>
                                      <th >Slot còn lại</th>
                                      <th >Hành động</th>
                                    </tr>
                                </thead>
                                <tbody >
                                    <tr v-if="classOpening.length == 0" class="text-center">
                                      <td colspan="11">
                                        Không có dữ liệu
                                      </td>
                                    </tr>
                                    <tr v-else v-for="(item, key) in classOpening" :key="key" style="font-size: 13px">
                                        <td>{{ item?.branch_name }}</td>
                                        <td>{{ item?.course_name }}</td>
                                        <td>{{ item?.class_name }}</td>
                                        <td>
                                            <el-tooltip
                                                effect="light"
                                                placement="top"
                                            >
                                                <template #content>
                                                    <div style="white-space: pre-line;">
                                                        {{ item?.schedule }}
                                                    </div>
                                                </template>
                                                <span>{{ item?.schedule_name }}</span>
                                            </el-tooltip>
                                        </td>
                                        <td>{{ formatDate(item?.start_date_expected) }}</td>
                                        <td>{{ formatDate(item?.start_date_latest) }}</td>
                                        <td>{{ formatDate(item?.start_date) }}</td>
                                        <td>
                                            <el-tag v-if="item?.recruitment_status" :type="getType(item?.recruitment_status)">{{ item?.recruitment_status_lable }}</el-tag>
                                        </td>
                                        <td>{{ item?.number_student }}</td>
                                        <td>{{ item?.remaining_slots }}</td>
                                        <td>
                                            <el-button type="primary" size="mini" title="Chi tiết" :disabled="studentsLoading" @click="openClassDetails(item)">
                                                Chi tiết
                                            </el-button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="edutalk-paging" >
                              <div class="block">
                                <el-pagination
                                    background
                                    @current-change="handleCurrentChange"
                                    :current-page.sync="paging.current_page"
                                    :page-size="paging.per_page"
                                    layout="prev, pager, next"
                                    :total="paging.total">
                                </el-pagination>
                              </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog
            title="Chi tiết lớp học"
            :visible.sync="classDetailsVisible"
            width="90%"
            top="5vh"
            append-to-body
        >
            <template v-if="selectedClass">
                <h5>Thông tin lớp học</h5>
                <el-form :model="selectedClass" label-position="top" :disabled="true" size="small">
                    <el-row :gutter="20">
                        <el-col v-for="field in classInformationFields" :key="field.key" :xs="24" :sm="12" :md="8">
                            <el-form-item :label="field.label">
                                <el-input
                                    :value="selectedClass[field.key]"
                                    :type="field.key === 'schedule' ? 'textarea' : 'text'"
                                    :autosize="{ minRows: 2, maxRows: 4 }"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>

                <h5>Danh sách học viên trong lớp</h5>
                <div v-loading="studentsLoading">
                    <div v-if="studentsError" class="mb-3">
                        <el-alert :title="studentsError" type="error" :closable="false" show-icon></el-alert>
                        <el-button class="mt-2" size="small" @click="getClassStudents">Thử lại</el-button>
                    </div>
                    <el-table
                        :data="classStudents"
                        border
                        max-height="400"
                        :empty-text="studentsLoading ? 'Đang tải danh sách học viên...' : (studentsError ? 'Chưa tải được danh sách học viên' : 'Không có học viên')"
                    >
                        <el-table-column prop="user_id" label="Mã HV" min-width="110"></el-table-column>
                        <el-table-column prop="name" label="Học viên" min-width="200"></el-table-column>
                        <el-table-column label="Học viên mới" min-width="130">
                            <template slot-scope="scope">{{ scope.row.is_first_course ? 'Có' : 'Không' }}</template>
                        </el-table-column>
                        <el-table-column prop="official" label="Trạng thái" min-width="140"></el-table-column>
                        <el-table-column label="Lớp học khóa trên" min-width="180">
                            <template slot-scope="scope">{{ scope.row.name_next_course == null ? 'Chưa có' : scope.row.name_next_course }}</template>
                        </el-table-column>
                    </el-table>
                </div>
            </template>
            <span slot="footer">
                <el-button @click="classDetailsVisible = false">Đóng</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { GET_COURSES, GET_OPENING_CLASS, GET_OPENING_CLASS_STUDENTS, GET_OPERATING_AREAS } from "../../../core/services/store/course/course.module";
import { debounce } from "lodash";
import { GET_CENTERS } from "../../../core/services/store/center/center.module";
import { GET_BRANCHES_ALL } from "../../../core/services/store/center/branch.module";

export default {
    name: "ClassOpeningStatus",
    data() {
        return {
            isLoading: false,
            classDetailsVisible: false,
            selectedClass: null,
            classStudents: [],
            studentsLoading: false,
            studentsError: '',
            classInformationFields: [
                { key: 'branch_name', label: 'Chi nhánh' },
                { key: 'course_name', label: 'Khóa học' },
                { key: 'class_name', label: 'Mã lớp' },
                { key: 'schedule', label: 'Lịch học' },
                { key: 'start_date_expected', label: 'KG sớm nhất' },
                { key: 'start_date_latest', label: 'KG muộn nhất' },
                { key: 'start_date', label: 'KG chính thức' },
                { key: 'recruitment_status_lable', label: 'Trạng thái' },
                { key: 'number_student', label: 'Sĩ số chuẩn' },
                { key: 'remaining_slots', label: 'Slot còn lại' },
            ],
            filter: {
                branch_id : [],
                center_id : null,
                course_id : [],
                keyword : '',
                schedule : [],
                recruitment_status : [],
                date_range : null,
                remaining_slots : null,
                operating_area_id : [],
            },
            centers : [],
            regionOptions : [],
            branches : [],
            courseOptions : [],
            enrollmentStatus : [
                { id: 1, name: 'Tuyển sinh', severity: 'success' },
                { id: 2, name: 'Tuyển sinh sau khai giảng', severity: 'info' },
                { id: 4, name: 'Full', severity: 'danger' },
            ],
            scheduleOptions : [
                { id: 1, name: 'Thứ 2' },
                { id: 2, name: 'Thứ 3' },
                { id: 3, name: 'Thứ 4' },
                { id: 4, name: 'Thứ 5' },
                { id: 5, name: 'Thứ 6' },
                { id: 6, name: 'Thứ 7' },
                { id: 0, name: 'Chủ nhật' },
            ],
            classOpening : [],
            paging: {
              current_page: 1,
              per_page: 20,
              total: 0,
            },
        }
    },
    watch: {
        filter: {
            handler(newFilter, oldFilter) {
                if (newFilter.date_range) {
                    const range = Array.isArray(newFilter.date_range) ? newFilter.date_range : [newFilter.date_range];
                    if (range.length < 2 || !range[0] || !range[1]) return;
                }
                this.debouncedGetList();
            },
            deep: true
        }
    },
    mounted() {
      this.getRegions();
      this.getCourses();
      this.getBranches()
      this.getCenters();
      this.getOpeningClass();
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: "Tình hình mở lớp", icon: 'far fa-user' }
      ]);
    },
    methods : {
        formatDate(value) {
            if (!value) return '';
            const date = this.$moment(value);
            return date.isValid() ? date.format('DD-MM-YYYY') : '';
        },
        openClassDetails(item) {
            if (this.studentsLoading) return;
            this.selectedClass = { ...item, schedule: item.schedule || item.schedule_name };
            this.classDetailsVisible = true;
            this.getClassStudents();
        },
        async getClassStudents() {
            if (this.studentsLoading) return;
            const classId = this.selectedClass?.id;
            this.classStudents = [];
            this.studentsError = '';
            this.studentsLoading = true;
            try {
                if (classId == null) {
                    throw new Error('Không tìm thấy mã định danh lớp học.');
                }
                const response = await this.$store.dispatch(GET_OPENING_CLASS_STUDENTS, classId);
                if (response.error) {
                    throw new Error(response.message || 'Không thể tải danh sách học viên.');
                }
                this.classStudents = response.data ?? [];
            } catch (error) {
                this.studentsError = error.response?.data?.message || error.message || 'Không thể tải danh sách học viên. Vui lòng thử lại.';
            } finally {
                this.studentsLoading = false;
            }
        },
        debouncedGetList: debounce(function () {
            this.paging.current_page = 1
            this.getOpeningClass();
        }, 500),
        getOpeningClass() {
            this.isLoading = true;
            this.$store.dispatch(GET_OPENING_CLASS,{
                ...this.filter,
                page : this.paging?.current_page
            }).then((data) => {
                this.classOpening = data.data ?? []
                this.paging.per_page = data?.pagination?.per_page
                this.paging.total = data?.pagination?.total
                this.paging.current_page = data?.pagination?.current_page
            }).catch((er) => {
                console.log(er)
            }).finally(() => {
                this.isLoading = false;
            });
        },
        getCenters() {
            this.$store.dispatch(GET_CENTERS , {is_edutalk : 1 , status : 1}).then((data) => {
                this.centers = data?.data?.data.map((item) => {
                    return {
                        id : item.id,
                        name : item?.name || item?.name_mkt
                    }
                })
            }).catch((er) => {
                console.log(er)
            })
        },
        getBranches() {
            this.$store.dispatch(GET_BRANCHES_ALL,
                {
                    operating_area_id : this.filter?.operating_area_id , center_id : this.filter.center_id ,
                    status: 1,
                    center_is_edutalk: 1
                    // all : true
                }
            ).then((data) => {
                this.branches = data?.data
            }).catch((er) => {
                console.log(er)
            })
        },
        getCourses(){
            this.$store.dispatch(GET_COURSES,{status: 1, is_edutalk: true, all: true , center_id : this.filter.center_id}).then((data) => {
                this.courseOptions = data?.data
            }).catch((er) => {
                console.log(er)
            })
        },
        getRegions(){
            this.$store.dispatch(GET_OPERATING_AREAS).then((data) => {
                this.regionOptions = data?.data
            }).catch((er) => {
                console.log(er)
            })
        },
        handleCurrentChange(val) {
          this.paging.current_page = val
          this.getOpeningClass();
        },
        getType(type) {
            switch(type){
                case 1 : return 'success';
                case 2 : return '';
                case 3 : return 'info';
                case 4 : return 'danger';
            }
        }
    }
}
</script>
